(() => {
  const loader = document.querySelector('[data-marame-qa-loader]');
  if (!loader) return;
  let loading;
  let latest = 0;
  const load = (url) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = resolve;
    script.onerror = () => { script.remove(); reject(new Error('Quick add unavailable')); };
    document.head.append(script);
  });
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-marame-quick-add]');
    if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || customElements.get('marame-quick-add')) return;
    const href = trigger.dataset.productUrl || trigger.getAttribute('href');
    const url = new URL(href, location.href);
    if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
    event.preventDefault();
    const run = ++latest;
    trigger.setAttribute('aria-busy', 'true');
    loading ||= (async () => {
      if (!customElements.get('product-form')) await load(loader.dataset.productFormSrc);
      await load(loader.dataset.quickAddSrc);
    })();
    try {
      await loading;
      if (run !== latest || !trigger.isConnected) return;
      const bag = trigger.closest('cart-drawer');
      if (bag && !bag.classList.contains('active')) return;
      const component = document.querySelector('marame-quick-add');
      const target = component?.productURL(href);
      if (!target) throw new Error('Quick add unavailable');
      component.show(trigger, target);
    } catch {
      loading = null;
      if (run === latest && trigger.isConnected) location.assign(url.href);
    } finally { trigger.removeAttribute('aria-busy'); }
  }, true);
})();
